import { FC } from 'react';
import _ from 'lodash';
import HoverMessage from 'common/components/HoverMessage';
import { STATUS_STYLE_CONFIG } from 'modules/OrderDetails/config';

enum OrderStatus {
  Cancelled = 'cancelled',
  Executed = 'executed',
  Failed = 'failed',
  Placed = 'placed',
}

interface Order {
  failure_message?: string | null;
}

interface OrderStatusWithMessageProps {
  status?: OrderStatus;
  order?: Order;
  className?: string;
}

interface StatusConfig {
  statusText: string;
  statusClassName: string;
}

export const getOrderStatusConfig = (status: OrderStatus | null): StatusConfig => {
  const statusConfig = _.get(STATUS_STYLE_CONFIG, status || '');
  const statusText = _.get(statusConfig, 'statusText', status) || '';
  const statusClassName = _.get(statusConfig, 'statusTextClassName', 'text-muted');

  return { statusText, statusClassName };
};

const OrderStatusWithMessage: FC<OrderStatusWithMessageProps> = ({
  status = null,
  order = {},
  className = '',
}) => {
  // Only show status when order has failed
  if (![OrderStatus.Failed].includes(status as OrderStatus)) return null;

  const failureMessage = _.get(order, 'failure_message', null);
  const { statusText, statusClassName } = getOrderStatusConfig(status);

  return (
    <div className={`d-flex align-items-center ${className}`}>
      <span className={`${statusClassName} status`}>{statusText}</span>
      {failureMessage && (
        <HoverMessage title="Message" message={failureMessage}>
          <span className="material-icons-outlined text-dark tx-12 align-middle ml-1">info</span>
        </HoverMessage>
      )}
    </div>
  );
};

export default OrderStatusWithMessage;
